export class Count {
  count: number;

  loading: boolean;

  constructor(count: number, loading: boolean) {
    this.count = count;
    this.loading = loading;
  }

  // set Count value
  setCount(count: number) {
    this.count = count;
  }

  // set loading state
  setLoading(loading: boolean) {
    this.loading = loading;
  }
}
